export default [{ name: "Algeria", code: "DZ" }];
